import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { resetFilter } from 'redux/actions/newFilter';
import {
  getListTransactions,
  updateStatus,
  manualDisburse,
} from '../../redux/actions/transactions';

import TransactionLog from './TransactionLog.page';

const mapStateToProps = state => ({
  loading: state.gold.loading,
  trxList: state.gold.trxList,
  trxFilter: state.gold.trxFilter,
  filterValue: state.newFilter.filterValue,
});

const mapDispatchToProps = {
  getListTransactions,
  resetFilter,
  updateStatus,
  manualDisburse,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(TransactionLog));
